<template>
  <div class="award_section">
    <div class="awards_image_upload">
      <v-alert
        v-if="error"
        :value="true"
        type="error"
        class="notranslate"
      >{{str.error_alert}}<br/>{{error}}</v-alert>
      <v-alert v-else-if="pending_payment"
               :value="true"
               type="warning"
               class="notranslate"
      >
        {{str.pending_payment}}
        <a v-if="get_last_payment && get_last_payment.details['payment_method'] === 'boleto' && validateTime(get_last_payment.details['boleto_expiration_date'])"
           :href="get_last_payment.details['boleto_url']"
           target="_blank"
        >{{str.view_bank_slip}}</a>
        <a v-else-if="get_last_payment && get_last_payment.details['payment_method'] === 'boleto' && !validateTime(get_last_payment.details['boleto_expiration_date'])"
           href="#"
           @click.prevent="payAwards(total_to_pay)"
        >{{str.expired_boleto}}</a>
        <a v-else
           href="#"
           @click.prevent="payAwards(total_to_pay)"
        >{{str.try_payment_again}}</a>
      </v-alert>
      <template v-else-if="!pending_payment">
        <v-alert
          v-if="total_entries < free_entries"
          :value="true"
          type="success"
          class="notranslate"
        >
          {{ !already_submitted ? $t('you_can_send_up_to') : $t('confirmed_can_send_more') }}
          {{ $t('free_and_extra_entries_available', [
          free_entries - total_entries,
          parseInt(award['max_entries'], 10) - free_entries,
          extra_entry_price_formatted
          ]) }}
        </v-alert>
        <v-alert
          v-else-if="total_entries >= free_entries && total_entries < parseInt(award['max_entries'], 10)"
          :value="true"
          type="info"
          class="notranslate"
        >
          <template v-if="!already_submitted">
            {{ $t('extra_entries_available_and_price', [
              parseInt(award['max_entries'], 10) - total_entries,
              extra_entry_price_formatted
            ]) }}
          </template>
          <template v-else>
            {{ $t('confirmed_can_send_more_extra', [
              parseInt(award['max_entries'], 10) - total_entries,
              extra_entry_price_formatted
            ]) }}
          </template>
        </v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && !already_submitted"
          :value="true"
          type="warning"
          class="notranslate"
        >{{ $t('maximum_reached') }}</v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && (already_submitted['submission'].length < parseInt(award['max_entries'], 10))"
          :value="true"
          type="warning"
          class="notranslate"
        >{{ $t('maximum_reached') }}</v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && (already_submitted['submission'].length >= parseInt(award['max_entries'], 10))"
          :value="true"
          type="success"
          class="notranslate"
        >{{ $t('maximum_reached_submitted') }}</v-alert>
      </template>
      <div class="awards_photos_upload" v-if="available >= 1 && canAddMore">
      <span class="limit">{{ available > 0
          ? `${str.limit_available} ${available} ${str.pictures}`
          : str.limit_reached
      }}</span>
        <input type="file"
               :multiple="(available > 1)"
               ref="image_uploader"
               value="upload dos arquivos"
               @change="upload"
        />
        <v-btn color="accent"
               @click.native="onFocus"
               :loading="loading"
               :disabled="loading || (available < 1)"
        >
          {{str.submit_pictures}}
          <v-icon class="notranslate" right dark>cloud_upload</v-icon>
        </v-btn>
        <span class="note">{{str.photos_alert}}</span>
        <span class="tutorial_link">
          <a href="https://youtu.be/fRDthHhqyXk" target="_blank">{{str.tutorial_link}}</a>
        </span>
      </div>
      <div class="awards_photos_gallery">
        <ul v-if="images.length > 0">
          <li v-for="(image, index) in images"
              :key="index"
              :style="image.substring(0, 4) === 'http' ? `background-image: url('${image}');` : `background-image: url('data:image/jpeg;charset=utf-8;base64,${image}');`"
              :class="(already_confirmed && index+1 <= already_confirmed ? 'already_confirmed' : (already_confirmed && index+1 <= already_submitted['submission'].length) ? 'already_submitted' : '')"
          >
            <div class="actions" v-if="!already_submitted || (already_submitted && (index+1 > already_submitted['submission'].length))">
              <v-tooltip bottom>
                <v-btn slot="activator"
                       flat
                       icon
                       color="#fff"
                       @click="removeImage(index)"
                >
                  <v-icon class="notranslate" medium>delete</v-icon>
                </v-btn>
                <span>{{str.remove_photo}}</span>
              </v-tooltip>
            </div>
          </li>
        </ul>
      </div>
      <AwardsBottomPay
        v-show="entries_to_submit >= 1"
        :total_to_pay="total_to_pay"
        @submit="confirm_dialog = true"
      />
    </div>
    <AwardsSideInfo :award="award"
                    :readyToSubmit="!loading"
                    :total_to_pay="total_to_pay"
                    :entries_to_submit="entries_to_submit"
                    :free_entries_available="free_entries_available"
                    :extra_entries="extra_entries"
                    :submission="images"
                    :profile="profile"
                    @submit="confirm_dialog = true"
    />
    <v-dialog v-model="confirm_dialog" persistent max-width="492">
      <v-card>
        <v-card-title class="headline">{{ str.confirm_submission }}?</v-card-title>
        <v-card-text>{{ str.rules_agreement }}</v-card-text>
        <v-card-text>
          {{ str.admit_judges_comments }}
          <v-radio-group v-model="admit_comments" column>
            <v-radio :label="str.admit_judges_comments_allow" value="allow"></v-radio>
            <v-radio :label="str.admit_judges_comments_refuse" value="refuse"></v-radio>
          </v-radio-group>
          <v-card-text class="admit_comments_allow_alert"
                       v-if="admit_comments === 'allow'"
          >{{ str.admit_judges_comments_accept_note }}</v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed
                 color="accent"
                 @click="submitAwards"
                 :disabled="!admit_comments"
          >{{ total_to_pay > 0 ? str.pay_and_submit : str.submit }}</v-btn>
          <v-btn flat
                 color="info"
                 :href="award[`rules_page_${lang}_url`]"
                 target="_blank"
          >{{ str.read_the_rules }}</v-btn>
          <v-btn flat @click="confirm_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="success_dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ str.success_dialog_title }}</v-card-title>
        <v-card-text>{{ str.success_dialog_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="success_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="error_dialog" persistent max-width="420">
      <v-card>
        <v-card-title class="headline">{{ str.error_dialog_title }}</v-card-title>
        <v-card-text>{{ str.error_dialog_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="accent" @click="submitAwards">{{str.try_again}}</v-btn>
          <v-btn flat @click="error_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="payment.dialog" max-width="470">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="success"
                  class="notranslate"
                  left
                  v-if="payment.status === 'paid'"
          >check_circle</v-icon>
          <v-icon color="info"
                  class="notranslate"
                  left
                  v-else-if="payment.status === 'waiting_payment'"
          >info</v-icon>
          <v-icon color="error"
                  class="notranslate"
                  left
                  v-else
          >warning</v-icon>
          {{payment.title}}
        </v-card-title>
        <v-card-text>{{payment.text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
                 v-if="payment.status === 'waiting_payment'"
                 color="accent"
                 :href="payment.url"
                 target="_blank"
          >{{str.view_bank_slip}}</v-btn>
          <v-btn flat
                 v-else-if="payment.status === 'refused'"
                 color="accent"
                 @click="submitAwards"
          >{{str.try_again}}</v-btn>
          <v-btn flat @click="payment.dialog = false">
            {{str.close}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="submitting" v-show="submitting.active">
      <h2>{{str.submiting}}</h2>
      <p v-if="submitting.current>0">
        {{str.processing_image}}
        {{submitting.current}}
        {{str.processing_image_of}}
        {{submitting.max}}
      </p>
      <p v-else>{{str.processing_submission}}</p>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AwardsSideInfo from './AwardsSideInfo'
import AwardsBottomPay from './AwardsBottomPay'
import VAlert from 'vuetify/es5/components/VAlert/VAlert'
import VBtn from 'vuetify/es5/components/VBtn/VBtn'
import VRadio from 'vuetify/es5/components/VRadioGroup/VRadio'
import VRadioGroup from 'vuetify/es5/components/VRadioGroup/VRadioGroup'
import strings from '../strings/AwardsImageUpload'
import paymentMixin from '../utils/payment_mixin'
import * as moment from 'moment'
import { validateImage } from '../utils/functions'
import { submitAwards, registerAwards } from '../utils/api'
import { UPDATE_USER, UPDATE_SEGMENTS } from '../store/types'
export default {
  name: 'AwardsImageUpload',
  components: { VBtn, VAlert, AwardsSideInfo, AwardsBottomPay, VRadio, VRadioGroup },
  mixins: [
    paymentMixin
  ],
  props: {
    award: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      images: [],
      confirm_dialog: false,
      success_dialog: false,
      error_dialog: false,
      admit_comments: '',
      submitting: {
        active: false,
        current: 0,
        max: 0
      },
      payment: {
        dialog: false,
        title: '',
        text: '',
        status: ''
      }
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.user.language ? this.$store.state.user.language : 'en'
    },
    str: function () {
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][this.lang]
        }
      }, {})
    },
    canAddMore: function () {
      if (this.already_submitted) {
        if (
          this.already_submitted['payment_status'] === 'paid' ||
          this.already_submitted['payment_status'] === 'completed' ||
          this.already_submitted['payment_status'] === 'free'
        ) {
          return (this.total_entries < this.award['max_entries'])
        } else {
          return false
        }
      } else {
        return (this.total_entries < this.award['max_entries'])
      }
    },
    profile: function () {
      return this.$store.state.segments
        .find(el => el.slug === this.award['participant_segment'])
    },
    total_entries: function () {
      return this.images.length
    },
    available: function () {
      return (this.award['max_entries'] - this.images.length)
    },
    already_submitted: function () {
      const awardsSubmissions = this.profile['data']['awards_submissions']
      const thisAwardsIndex = Object.keys(awardsSubmissions).find(el => el == this.award['id'])
      if (thisAwardsIndex) {
        return awardsSubmissions[thisAwardsIndex]
      } else {
        return false
      }
    },
    already_confirmed: function () {
      if (this.already_submitted) {
        if (this.already_submitted['submission'].length <= this.free_entries) {
          return this.already_submitted['submission'].length
        } else {
          const alreadyPaidFor = Math.round(this.already_submitted['amount_paid'] / this.extra_entry_price)
          return alreadyPaidFor + this.free_entries
        }
      } else {
        return 0
      }
    },
    entries_to_submit: function () {
      if (this.already_submitted) {
        return Math.max(0, (this.total_entries - this.already_confirmed))
      } else {
        return this.total_entries
      }
    },
    free_entries: function () {
      return this.profile.data.is_pro
        ? parseInt(this.award['free_entries'], 10)
        : 1
    },
    free_entries_available: function () {
      const defaultFreeEntries = this.free_entries
      if (this.already_submitted) {
        return Math.max(0, (defaultFreeEntries - this.already_submitted['submission'].length))
      } else {
        return defaultFreeEntries
      }
    },
    extra_entries: function () {
      return Math.max(0, (this.entries_to_submit - this.free_entries_available))
    },
    extra_entry_price: function () {
      const entry_field = this.$store.state.user['address']['country'].toLowerCase() === 'br'
        ? 'entry_price_brl'
        : 'entry_price_usd'
      const value = parseInt(this.award[entry_field], 10)
      return this.profile.data.is_pro ? value : value * 2
    },
    extra_entry_price_formatted: function () {
      const amount = (this.extra_entry_price / 100).toFixed(2)
      return (this.$store.state.user['address']['country'].toLowerCase() === 'br')
          ? amount.replace('.', ',')
          : amount
    },
    total_to_pay: function () {
      return this.extra_entries * this.extra_entry_price
    },
    pending_payment: function () {
      if (this.already_submitted) {
        return !(
          this.already_submitted['payment_status'] === 'paid' ||
          this.already_submitted['payment_status'] === 'completed' ||
          this.already_submitted['payment_status'] === 'free'
        )
      } else {
        return false
      }
    },
    pending_payment_message: function () {
      if (this.pending_payment) {
        if (
          this.get_last_payment &&
          this.get_last_payment.details['payment_method'] === 'boleto' &&
          this.validateTime(this.get_last_payment.details['boleto_expiration_date'])
        ) {
          return {
            message: this.str.view_bank_slip,
            url: this.get_last_payment.details['boleto_url']
          }
        } else if (
          this.get_last_payment &&
          this.get_last_payment && this.get_last_payment.details['payment_method'] === 'boleto' &&
          !this.validateTime(this.get_last_payment.details['boleto_expiration_date'])
        ) {
          return {
            message: this.str.expired_boleto,
            url: null
          }
        } else {
          return {
            message: this.str.try_again,
            url: null
          }
        }
      } else {
        return null
      }
    },
    get_last_payment: function () {
      if (this.already_submitted) {
        return this.$store.state.user['payment_history']
          .find(el => el.id === this.already_submitted['payment_id'])
      } else {
        return null
      }
    }
  },
  methods: {
    validateTime: function (time) {
      return moment().isBefore(time * 1000)
    },
    onFocus: function () {
      this.$refs.image_uploader.click()
    },
    upload: function () {
      this.loading = true
      this.error = false
      if (this.$refs.image_uploader.files.length <= this.available) {
        const images = Array.prototype.map.call(
          this.$refs.image_uploader.files,
          image => validateImage(image, 1200, 800).then(data => data)
        )
        Promise.all(images).then(base64Imgs => {
          this.images = [
            ...this.images,
            ...base64Imgs
          ]
          this.loading = false
        }).catch(error => {
          this.error = `${this.str.file} ${error.message} ${this.str.requirements}.`
          this.loading = false
        })
      } else {
        this.error = `${this.str.submit_limit} ${this.available} ${this.str.files}.`
        this.loading = false
      }
    },
    removeImage: function (index) {
      this.images = this.images.filter((el, i) => i !== index)
    },
    submitAwards: async function () {
      this.payment.dialog = false
      this.confirm_dialog = false
      this.error_dialog = false
      this.submitting.active = true
      this.submitting.current = 0
      this.submitting.max = 0
      const totalToPay = this.total_to_pay
      console.log('total to pay', totalToPay)
      const imagesToSubmit = this.images.slice(this.already_submitted
        ? this.already_submitted['submission'].length
        : 0
      )
      const submissionChunks = imagesToSubmit.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 2)
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []
        }
        resultArray[chunkIndex].push(item)
        return resultArray
      }, [])
      let submitResult = []
      let errorCatched = false
      this.submitting.max = this.entries_to_submit
      console.log(submissionChunks)
      let submissionChunksIndex = 1
      for (const el of submissionChunks) {
        if (errorCatched) break
        this.submitting.current = submissionChunksIndex
        await submitAwards(this.profile['data']['id'], this.award['id'], [el])
          .then(result => {
            if (!(result instanceof TypeError)) {
              console.log(result)
              submitResult.push(result)
              submissionChunksIndex = submissionChunksIndex + 2
            } else {
              errorCatched = true
            }
          })
          .catch(err => {
            console.log(err)
            errorCatched = true
          })
      }
      if (errorCatched) {
        this.submitting.active = false
        this.error_dialog = true
        return
      }
      console.log(submitResult, 'submitResult')
      if (submitResult.find(el => el instanceof TypeError)) {
        this.submitting.active = false
        this.error_dialog = true
      } else {
        const finalSubsmission = submitResult.reduce((acc, cur) => {
          return [
            ...acc,
            ...cur['awards_submission']
          ]
        }, [])
        console.log(finalSubsmission, 'finalSubsmission')
        registerAwards(
          this.profile['data']['id'],
          this.award['id'],
          finalSubsmission,
          this.admit_comments
        ).then(finalResult => {
          if (finalResult['result'] === 'success') {
            this.$store.commit(UPDATE_USER, finalResult['new_user'])
            this.$store.commit(UPDATE_SEGMENTS, finalResult['new_segments'])
            this.submitting.active = false
            this.updateImagesSubmitted()
            if (totalToPay > 0) {
              this.payAwards(totalToPay)
            } else {
              this.success_dialog = true
            }
          }
        })
      }
    },
    payAwards: function (totalToPay = 0) {
      console.log('payAwards invoked')
      const realTotalToPay = (totalToPay === 0) ? this.total_to_pay : totalToPay
      this.makePayment(
        realTotalToPay,
        {
          finality: 'awards',
          extra_entries: this.extra_entries.toString(),
          awards_title: this.award['title'],
          awards_id: this.award['id'],
          post_id: this.profile['data']['id'],
          user_id: this.$store.state.user.id
        },
        'boleto, credit_card'
      ).then(paymentResult => {
        console.log(paymentResult)
        this.updateImagesSubmitted()
        this.payment.dialog = true
        this.payment.title = paymentResult.title
        this.payment.text = paymentResult.text
        this.payment.status = paymentResult.status
        this.payment.url = paymentResult.url
      })
    },
    updateImagesSubmitted: function () {
      if (this.already_submitted) {
        this.images = [
          ...Object.values(this.already_submitted['submission'])
        ]
      }
    }
  },
  mounted () {
    this.updateImagesSubmitted()
  }
}
</script>

<style scoped lang="scss">
  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      transform: scale(0);
    } 40% {
        transform: scale(1.0);
      }
  }
  .v-alert {
    position: sticky;
    top: 84px;
    z-index: 39;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    font-size: 16px;
    a {
      color: #fff;
    }
  }
  .admit_comments_allow_alert {
    background: var(--warning-color);
    color: #fff;
  }
  .submitting {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.75);
    z-index: 999999;
    padding: 96px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    pointer-events: none;
    h2 {
      color: #fff;
      font-size: 36px;
    }
    p {
      color: #fff;
      margin: 0;
      font-size: 24px;
    }
    .spinner {
      margin: 48px auto 0;
      width: 84px;
      text-align: center;
      div {
        width: 24px;
        height: 24px;
        margin: 0 2px;
        background-color: rgba(255,255,255,0.7);
        border-radius: 100%;
        display: inline-block;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        &.bounce1 {
          animation-delay: -0.32s;
        }
        &.bounce2 {
          animation-delay: -0.16s;
        }
      }
    }
  }
  .awards_photos_upload {
    margin-bottom: 36px;
    margin-top: 24px;
    text-align: center;
    input[type=file] {
      display: none;
    }
    .limit {
      display: block;
      font-size: 16px;
    }
    .note {
      display: block;
      margin-top: 12px;
    }
    .tutorial_link {
      display: inline-block;
      margin: 4px 0;
      background: var(--warning-color);
      padding: 4px 6px;
      line-height: 24px;
      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
  .awards_photos_gallery {
    ul {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 4px;
      margin: 24px 0 0 0;
      padding: 0;
      list-style: none;
      li {
        display: block;
        position: relative;
        padding-top: 100%;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        &:hover .actions {
          opacity: 1;
        }
        .actions {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        }
        &.already_submitted,
        &.already_confirmed {
          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(255, 255, 255, 0.7);
            z-index: 3;
          }
        }
        &.already_submitted::after,
        &.already_confirmed::after {
          font-family: 'Material Icons';
          font-weight: normal;
          font-style: normal;
          letter-spacing: normal;
          text-transform: none;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          word-wrap: normal;
          direction: ltr;
          -webkit-font-feature-settings: 'liga';
          -webkit-font-smoothing: antialiased;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          font-size: 48px;
          text-align: center;
          line-height: 1em;
          z-index: 5;
        }
        &.already_submitted::after {
          content: 'warning';
          color: var(--warning-color);
        }
        &.already_confirmed::after {
          content: 'check_circle';
          color: var(--success-color);
        }
      }
    }
  }
</style>

<i18n>
  {
    "en": {
      "you_can_send_up_to": "You can send up to",
      "confirmed_can_send_more": "Your participation in this contest has already been confirmed, but you can still submit up to",
      "free_and_extra_entries_available": "{0} more entries for free and {1} more extra entries for U$ {2} each",
      "extra_entries_available_and_price": "You can send up to {0} more entries for U$ {1} each",
      "confirmed_can_send_more_extra": "Your participation in this contest has already been confirmed, but you can still submit up to {0} more entries for U$ {1} each",
      "maximum_reached": "You have reached the maximum number of entries allowed",
      "maximum_reached_submitted": "Your participation in this contest has already been performed and your submission contains the maximum number of entries allowed"
    },
    "pt": {
      "you_can_send_up_to": "Você pode enviar até mais",
      "confirmed_can_send_more": "Sua participação neste concurso já está confirmada, mas você ainda pode enviar até mais",
      "free_and_extra_entries_available": "{0} entrada(s) gratuitamente e mais {1} entrada(s) extras por R$ {2} cada",
      "extra_entries_available_and_price": "Você pode enviar até mais {0} entradas extras por R$ {1} cada",
      "confirmed_can_send_more_extra": "Sua participação neste concurso está confirmada, mas você pode enviar até mais {0} entradas extras por R$ {1} cada",
      "maximum_reached": "Você chegou ao máximo de entradas permitidas",
      "maximum_reached_submitted": "Sua participação neste concurso já foi realizada e seu envio contém o máximo de entradas permitidas"
    }
  }
</i18n>
